module.exports = __webpack_public_path__ + "img/head_bg3.c47e8128.png";